import { CandyOutlineIcon } from './CandyOutlineIcon';

/**
 * author: Michael Irigoyen
 * id B2A0C20C-2A90-4A9F-8C95-179D2ED89002
 * name candy-outline
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/candy-outline.svg
 * tags
 * - Food / Drink 
 * - Gaming / RPG 
 */
export const NaviIcon = CandyOutlineIcon;
export default NaviIcon